import { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { mainRouteInitial } from '../../Data/Constant.jsx';
import { useMainVendorUserLogin, useUserRegistration, useVerifyOTP } from '../../API_Master/MutateAPI.jsx';
import "./index.css"
// import FloatingMessage from '../../Components/FloatingMessage.jsx';
import { handleVenderLogOut, notifyError, notifySuccess } from '../../HelperMethods/index.jsx';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
// Validation Schemas
const MobileSchema = Yup.object().shape({
  mobile: Yup.string()
    .required('Owner mobile number is required')
    .matches(/^[1-9]\d{9}$/, 'Enter a valid 10-digit mobile number')
    .length(10, 'Owner mobile number must be exactly 10 digits'),
});

const OTPSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{6}$/, 'OTP must be exactly 6 digits')
    .required('OTP is required'),
});

const VendorLogin = () => {
  const { mutate: userLogin, isPending: signingIn } = useMainVendorUserLogin();
  const { mutate: verifyOTP, isPending: verifingOTP } = useVerifyOTP();
  const navigate = useNavigate()
  const [step, setStep] = useState('mobile');
  const [mobileNumber, setMobileNumber] = useState('');
  const [userTokenUniqueID, setUserTokenUniqueID] = useState("")
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    handleVenderLogOut()
  }, [])

  const handleSendOTP = async (values) => {
    try {

      const payload = {
        "MobileNo": values?.mobile || mobileNumber || "",
        "CurrentLoginType": "web",
        "FCMToken": ""
      }
      userLogin(payload, {
        onSuccess: (res) => {

          if (res?.status === true) {
            const loginOTP = res?.data?.[0]?.LoginOTP || ""
            const userTokenUniqueID = res?.data?.[0]?.UserTokenUniqueID || ""
            if (!userTokenUniqueID) {
              setUserTokenUniqueID("")
              return notifyError(res?.message || "Couldnt Send OTP")
            }
            setUserTokenUniqueID(userTokenUniqueID)
            setMobileNumber(values.mobile || mobileNumber);
            setStep('otp');
            // return notifySuccess("OTP Send Successfully :  " + loginOTP)
            return notifySuccess("OTP Send Successfully")
          } else {
            setUserTokenUniqueID("")
            return notifyError(res?.message || "Couldnt Send OTP")
          }
        },
        onError: (err) => {
          return notifyError(err?.message || "Couldnt Send OTP")
        }
      });
    } catch (err) {
      console.log(err?.message)
    }
  };

  const handleVerifyOTP = async (values) => {

    try {
      const payload = {
        "UserTokenUniqueID": userTokenUniqueID || "",
        "LoginOTP": values?.otp || ""
      }
      verifyOTP(payload, {
        onSuccess: (res) => {

          if (res?.status === true) {
            const venderUserID = res?.data?.[0]?.UserID || ""
            const userLoginJwtToken = res?.data?.[0].UserTokenDetailData?.[0]?.JWTToken || ""
            const userTokenUniqueID = res?.data?.[0]?.UserTokenDetailData?.[0]?.UserTokenUniqueID || ""
            if (!venderUserID) {
              return notifyError("Oppss! Could'nt Sign In, Please Try Again Later")
            }
            Cookies.set("NIGHT_EYE_USER_ID", venderUserID)
            Cookies.set("NIGHT_EYE_JWT_TOKEN", userLoginJwtToken)
            Cookies.set("NIGHT_EYE_USER_TOKEN_UNIQUE_ID", userTokenUniqueID)
            // Cookies.set("MAIN_LOGIN_TYPE", "Department")

            setShowSuccessModal(true);
            setTimeout(() => {
              const currentLoginUserType = res?.data?.[0]?.UserRoleDetail?.[0]?.UserRole
              const currentLoginName = res?.data?.[0]?.Name
              Cookies.set("NIGHT_EYE_USER_ROLE", currentLoginUserType)
              Cookies.set("NIGHT_EYE_USER_NAME", currentLoginName)
              if (currentLoginUserType?.toLowerCase() == "shop") {
                return navigate(`/${mainRouteInitial}/VendorDashboard`)
              }
              navigate(`/${mainRouteInitial}/VendorDashboard`)

            }, 2000);
          } else {
            // setUserTokenUniqueID("")
            return notifyError(res?.message || "Oppss! Could'nt Sign In, Please Try Again Later")
          }
        },
        onError: (err) => {
          return notifyError(err?.message || "Oppss! Could'nt Sign In, Please Try Again Later")
        }
      });
    } catch (err) {
      console.log(err?.message)
    }

  };

  return (
    <>

      <div className="relative flex min-h-screen w-full flex-row overflow-hidden">
        {/* Left Hero Section */}
        <div className="relative hidden w-full lg:flex lg:w-3/5 flex-col justify-between bg-surface-dark overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              alt="Abstract compliance background"
              className="h-full w-full object-contain"
              src={require("../../Assets/VendorLoginBanner.png")}
            />
            {/* <div className="absolute inset-0 bg-gradient-to-b from-primary/80 to-slate-900/90 mix-blend-multiply" /> */}
          </div>
          <div className="relative z-10 p-12 flex flex-col h-full justify-between">
            <div className='mx-auto w-full  -mt-8 lg:-mt-6'>
              <div className="flex items-center gap-3 mb-6">
                <div className="flex items-center justify-center size-10 rounded-lg bg-blue-100/80 backdrop-blur-sm text-blue-700">
                  <span className="material-symbols-outlined text-2xl">shield_person</span>
                </div>
                <h2 className="text-blue-800 text-xl font-bold tracking-tight">Nighteye</h2>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Login Form */}
        <div className="flex w-full lg:w-2/5 flex-col bg-background-light dark:bg-background-dark relative">
          <div className="lg:hidden px-6 py-4 flex items-center justify-between border-b border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark">
            <div className="flex items-center gap-2 text-[#0d141b] dark:text-white">
              <div className="flex items-center justify-center size-8 rounded bg-primary/10 text-primary">
                <span className="material-symbols-outlined text-lg">shield_person</span>
              </div>
              <span className="font-bold text-lg">Nighteye</span>
            </div>
          </div>
          {/* 
          <div className="absolute top-0 right-0 p-6 hidden lg:flex">
            <button className="flex items-center gap-2 text-sm font-medium text-[#4c739a] hover:text-primary transition-colors">
              <span className="material-symbols-outlined text-lg">help</span>
              Help &amp; Support
            </button>
          </div> */}

          <div className="flex flex-1 flex-col justify-center px-6 py-12 sm:px-12 lg:px-24 login-padding">
            <div className="mx-auto w-full max-w-[440px]">
              <div className="mb-10 text-center lg:text-left">
                <h1 className="text-[#0d141b] dark:text-white text-[32px] font-bold leading-tight tracking-tight mb-3">
                  Nighteye
                </h1>
                <p className="text-[#4c739a] dark:text-slate-400 text-base font-normal leading-relaxed">
                  {step === 'mobile'
                    ? 'Enter your 10-digit mobile number to receive an OTP.'
                    : `Enter the 6-digit OTP sent to ${mobileNumber}`}
                </p>
              </div>

              {/* Mobile Step */}
              {step === 'mobile' && (
                <Formik initialValues={{ mobile: '' }} validationSchema={MobileSchema} onSubmit={handleSendOTP}>
                  {({ errors, touched, isSubmitting, setFieldValue }) => (
                    <Form className="space-y-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-[#0d141b] dark:text-white">Owner Mobile Number</label>
                        <div className="relative">
                          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#4c739a] dark:text-slate-500 material-symbols-outlined">
                            smartphone
                          </span>
                          <Field
                            name="mobile"
                            type="tel"
                            inputMode="numeric"
                            maxLength="10"
                            placeholder="Enter Owner Mobile Number"
                            className={`w-full rounded-lg border pl-11 pr-4 py-3.5 text-[#0d141b] dark:text-white bg-surface-light dark:bg-surface-dark placeholder-[#4c739a] dark:placeholder-slate-500 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all shadow-sm text-base ${errors.mobile && touched.mobile ? 'border-red-500' : 'border-border-light dark:border-border-dark'
                              }`}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                              setFieldValue('mobile', value);
                            }}
                          />
                        </div>
                        {errors.mobile && touched.mobile && <p className="text-red-700 text-xs font-bold font-bold ">{errors.mobile}</p>}
                      </div>

                      <button
                        type="submit"
                        disabled={signingIn}
                        className="w-full rounded-lg bg-primary hover:bg-blue-600 disabled:opacity-70 text-white font-bold h-12 px-6 flex items-center justify-center gap-2 transition-all shadow-md hover:shadow-lg active:scale-[0.98]"
                      >
                        {signingIn ? 'Sending OTP...' : 'Send OTP'}
                        <span className="material-symbols-outlined text-lg">send</span>
                      </button>
                    </Form>
                  )}
                </Formik>
              )}

              {/* OTP Step */}
              {step === 'otp' && (
                <Formik initialValues={{ otp: '' }} validationSchema={OTPSchema} onSubmit={handleVerifyOTP}>
                  {({ errors, touched, isSubmitting, setFieldValue }) => (
                    <Form className="space-y-6">
                      <div className="space-y-2">
                        <div className="flex items-center justify-between">
                          <label className="block text-sm font-medium text-[#0d141b] dark:text-white">One-Time Password (OTP)</label>
                          <span onClick={handleSendOTP} className="cursor-pointer text-sm font-bold text-primary hover:text-primary/80">
                            Resend OTP
                          </span>
                          {/* <button  className="text-sm font-bold text-primary hover:text-primary/80">
                              Resend OTP
                          </button> */}
                        </div>
                        <div className="relative">
                          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#4c739a] dark:text-slate-500 material-symbols-outlined">lock</span>
                          <Field
                            name="otp"
                            type="text"
                            maxLength="6"
                            inputMode="numeric"
                            placeholder="••••••"
                            className={`w-full rounded-lg border pl-11 pr-4 py-3.5 text-center text-2xl tracking-widest font-mono text-[#0d141b] dark:text-white bg-surface-light dark:bg-surface-dark focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all shadow-sm ${errors.otp && touched.otp ? 'border-red-500' : 'border-border-light dark:border-border-dark'
                              }`}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                              setFieldValue('otp', value);
                            }}
                          />
                        </div>
                        {errors.otp && touched.otp && <p className="text-red-700 text-xs font-bold font-bold ">{errors.otp}</p>}

                      </div>

                      <button
                        type="submit"
                        disabled={verifingOTP}
                        className="w-full rounded-lg bg-primary hover:bg-blue-600 disabled:opacity-70 text-white font-bold h-12 px-6 flex items-center justify-center gap-2 transition-all shadow-md hover:shadow-lg active:scale-[0.98]"
                      >
                        {verifingOTP ? 'Verifying...' : 'Verify & Login'}
                        <span className="material-symbols-outlined text-lg">login</span>
                      </button>
                    </Form>
                  )}
                </Formik>
              )}
            </div>

            {/* Footer */}
            <div className="mt-12 text-center">
              <p className="text-xs text-[#4c739a] dark:text-slate-500">
                <a href="https://smtechno.com/" target="_blank" className=" hover:text-primary">2026 © S M Techno Consultants PVT LTD&nbsp;&nbsp;    </a> All rights reserved. <br />
                {/* <a className="underline hover:text-primary" href="#">Privacy Policy</a> • <a className="underline hover:text-primary" href="#">Terms of Service</a> */}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Beautiful Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="animate-in fade-in zoom-in duration-300">
            <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl p-10 max-w-sm w-full mx-4 text-center border border-green-200 dark:border-green-800">
              {/* Success Checkmark Circle */}
              <div className="mx-auto size-20 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mb-6">
                <span className="material-symbols-outlined text-5xl text-green-600 dark:text-green-400 animate-check">
                  check_circle
                </span>
              </div>

              <h2 className="text-2xl font-bold text-[#0d141b] dark:text-white mb-3">Successfully Signed In!</h2>
              <p className="text-[#4c739a] dark:text-slate-400 mb-6">
                Redirecting ...
              </p>

              <div className="flex justify-center">
                <div className="animate-spin rounded-full size-8 border-4 border-primary border-t-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Custom CSS for check animation */}
      <style jsx>{`
      
      `}</style>
    </>
  );
};

export default VendorLogin;